
export default (state = [], payload) => {
    switch(payload.type) {  
        case 'UPDATE_MEDIALIBRARY_HEIGHT':
            return payload.data;         
        default:
            return state;
    }
}
